import * as t from "./actions";

import { Merchant } from "./constants";

export interface MerchantState {
  merchant: Merchant[];
}

let initialState: Merchant[] = [];

export default function (state = initialState, action: IPayload): Merchant[] {
  switch (action.type) {
    case t.ADD_MERCHANTS:
      return [].concat(action.payload);

    case t.GET_MERCHANTS_FAILURE:
      console.error("getMerchants failed!");
      return state;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/modules/Merchant/reducer.ts